var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3431 12.1326C19.6409 11.5959 18.5311 11.5498 17.8027 12.2748L15.9945 14.0751C15.7607 13.3783 15.059 12.8709 14.2318 12.8709H11.0049C10.76 12.8709 10.678 12.7841 10.2527 12.4802C8.631 11.1691 6.19524 11.1733 4.57849 12.4928L3.3924 13.4612C2.85924 13.1995 2.23666 13.193 1.70059 13.4414L0.340184 14.0721C0.0362581 14.2132 -0.0867477 14.5559 0.064969 14.8378L3.75617 21.6845C3.90834 21.9664 4.27785 22.0805 4.58177 21.9397L5.94218 21.3087C6.61274 20.998 6.98594 20.3635 6.96174 19.7176H14.2317C15.5798 19.7176 16.868 19.1204 17.6768 18.1201L20.6302 14.4677C21.2031 13.7598 21.1125 12.7217 20.3431 12.1326ZM4.58173 20.6639L5.39175 20.2881C5.69567 20.147 5.81872 19.8047 5.66696 19.5229L3.07617 14.7172C2.924 14.435 2.5549 14.3212 2.25098 14.462L1.44055 14.8378L4.58173 20.6639ZM16.6925 17.4354L19.6459 13.783C19.8333 13.5517 19.8071 13.2136 19.5635 13.0158C19.3305 12.8267 18.9507 12.8062 18.703 13.0527L15.9945 15.7492C15.6467 16.0957 15.1545 16.2942 14.6439 16.2942H11.0897C10.7502 16.2942 10.4745 16.0386 10.4745 15.7237C10.4745 15.4088 10.7501 15.1531 11.0897 15.1531H14.2317C14.5709 15.1531 14.8469 14.8971 14.8469 14.5826C14.8469 14.268 14.5709 14.012 14.2317 14.012H11.0048C10.5627 14.012 10.1382 13.9066 9.45574 13.3494C8.29713 12.4042 6.54995 12.4042 5.39134 13.3494L4.22699 14.2999L6.53235 18.5765H14.2318C15.1947 18.5765 16.1147 18.1501 16.6925 17.4354Z",
    fill: "url(#paint0_radial_1602_21223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3979 1C13.6163 1 12.844 1.29366 12.2494 1.8027C11.6546 1.29363 10.8823 1 10.1007 1C8.36157 1 6.99927 2.35925 6.99927 4.09442C6.99927 6.19191 8.46291 7.47393 10.6784 9.41452C10.8677 9.5804 11.0632 9.75155 11.2643 9.92899C11.2657 9.9302 11.267 9.93144 11.2684 9.93264L11.9373 10.5091C12.027 10.5864 12.1382 10.625 12.2494 10.625C12.3607 10.625 12.4719 10.5864 12.5615 10.5091L13.2303 9.93264C13.2317 9.93144 13.2331 9.93023 13.2344 9.92902C14.5586 8.76062 15.5513 7.86612 16.2696 6.99372C17.1086 5.97481 17.4993 5.05354 17.4993 4.09445C17.4993 2.35925 16.137 1 14.3979 1Z",
    fill: "url(#paint1_radial_1602_21223)",
    stroke: "url(#paint2_radial_1602_21223)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1602_21223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.90769 13.4385) rotate(32.25) scale(16.0444 14.8751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1602_21223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.45311 2.77692) rotate(49.1568) scale(10.3742 10.5441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1602_21223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.45311 2.77692) rotate(49.1568) scale(10.3742 10.5441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportSelected);
export default __webpack_public_path__ + "static/media/support-selected.aca1ffb2ffffbe7fdbaf44284224f24d.svg";
export { ForwardRef as ReactComponent };